import { createRouter, createWebHashHistory } from 'vue-router'
import JobDetail from '../components/JobDetail.vue';


const routes = [
  {
    path: '/',
    redirect: '/about',
    // name: 'home',
    // component: () => import(/* webpackChunkName: "about" */ '../views/HomeView.vue'),
    // props: route => ({ language: route.query.lang || 'zh-CN' })
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue'),
    props: route => ({ language: route.query.lang || 'zh-CN' })
  },
  {
    path: '/careers',
    name: 'careers',
    component: () => import(/* webpackChunkName: "about" */ '../views/CareersView.vue'),
    props: route => ({ language: route.query.lang || 'zh-CN' })
  },
  {
    path: '/careers/:id',
    component: JobDetail
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import(/* webpackChunkName: "about" */ '../views/ContactView.vue'),
    props: route => ({ language: route.query.lang || 'zh-CN' })
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
